import { createIdentifier } from '@wix/thunderbolt-ioc'
import type { IDomStore, ISvgFetcher, ISvgDomStoreLoader } from './types'

export const name = 'domStore' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'

export const DomStoreSymbol = createIdentifier<IDomStore>(Symbol('DomStore'))
export const SvgFetcherSymbol = createIdentifier<ISvgFetcher>(Symbol('SvgFetcher'))
export const SvgDomStoreLoaderSymbol = createIdentifier<ISvgDomStoreLoader>(Symbol('SvgDomStoreLoader'))
